import request from '@/request'

const state = {
	ksh5gj71_login: {},
}
const mutations = {
	ksh5gj71_login(state, payload) {
		state.ksh5gj71_login = payload;
	},
}
const actions = {
	// 登录
	async ksh5gj71_login({ commit }, payload) {
        let res = await request.post('/user/signinmessage', {
			account: payload.account,
			code: payload.code,
		})
		commit('ksh5gj71_login', res);
	},
}

export default {
	state,
	mutations,
	actions
}
